const Translation = {
    id:{
        Hospitality:"Hotel",
		HospitalityReport:"Laporan Hotel",
        HospitalityConfiguration:"Konfigurasi Hotel",

		//Partner
		"Partner":"Partner",
		"partner":"Partner",
		"partner.activate":"Aktifkan",
		"Partner.confirmTitle.activate":"Aktifkan",
		"Partner.confirmContent.activate":"Apakah Anda yakin ingin mengaktifkan Partner ini?",
		"Partner.success.activate":"Partner telah berhasil diaktifkan",
		"partner.deactivate":"Nonaktifkan",
		"Partner.confirmTitle.deactivate":"Nonaktifkan",
		"Partner.confirmContent.deactivate":"Apakah Anda yakin ingin menonaktifkan Partner ini?",
		"Partner.success.deactivate":"Partner telah berhasil dinonaktifkan",
		"Partner Information":"Informasi Partner",
		"Partner.name":"Nama",
		"Partner.isSupplier":"Supplier",
		"Partner.isCustomer":"Pelanggan",
		"Partner.email":"Email",
		"Partner.mobile":"Nomor HP",
		"Partner.contact":"Nomor Telepon Rumah",
		"Partner.street":"Alamat",
		"Partner.cityId":"Kota",
		"Partner.city":"Kota",
		"Partner.provinceId":"Provinsi",
		"Partner.province":"Provinsi",
		"Partner.countryId":"Negara",
		"Partner.country":"Negara",
		"Partner.zip":"Kode Pos",
		"Partner.ssid":"Nomor KTP",
		"Partner.idAttachment":"Lampiran KTP",
		"Finance and Accounting":"Keuangan and Akunting",
		"Partner.unlimitedCredit":"Kredit Tidak Terbatas",
		"Partner.creditLimit":"Plafon Kredit",
		"Partner.credit":"Kredit",
		"Partner.debitLimit":"Plafon Debit",
		"Partner.debit":"Debit",
		"Partner.taxable":"Kena Pajak",
		"Partner.npwp":"NPWP",
		"Partner.defaultCurrencyId":"Kurs Standar",
		"Partner.defaultCurrency":"Kurs Standar",
		"Partner.purchaseInvoiceDaysDue":"Jatuh Tempo Tagihan Pembelian (Hari)",
		"Partner.salesInvoiceDaysDue":"Jatuh Tempo Tagihan Penjualan (Hari)",
		"Branch Information":"Informasi Cabang",
		"Partner.branchId":"Cabang",
		"Partner.branch":"Cabang",
		"Company Information":"Informasi Perusahaan",
		"Partner.isCompany":"Perusahaan",
		"Partner.companyName":"Nama Perusahaan",
		"Partner.companyNpwp":"NPWP Perusahaan",
		"Partner.companyAddress":"Alamat Perusahaan",
		"Partner.companyCityId":"Kota Perusahaan",
		"Partner.companyCity":"Kota Perusahaan",
		"Partner.companyProvinceId":"Provinsi Perusahaan",
		"Partner.companyProvince":"Provinsi Perusahaan",
		"Partner.companyCountryId":"Negara Perusahaan",
		"Partner.companyCountry":"Negara Perusahaan",
		"Partner.companyZip":"Kode Pos Perusahaan",
		"Other Information":"Informasi Lain",
		"Partner.nodeId":"Titik",
		"Partner.node":"Titik",
		"Partner.joinDate":"Tanggal Bergabung",
		"Partner.media":"Media",
		"Partner.class":"Kelas",
		"Partner.code":"Kode",
		"Partner.state":"Status",
		"Partner.purchasing":"Pembelian",
		"Partner.purchasingUsers":"Penanggung Jawab",
		"Partner.user":"Nama Staf",
		"Partner.birthDate":"Tanggal Lahir",
		"Partner.idNumber":"No. KTP",
		"Partner.idAddress":"Alamat KTP",
		"Partner.address":"Alamat Lengkap",
		"Partner.occupation":"Pekerjaan",
		"Partner.maritalStatus":"Status Pernikahan",
		"Partner.incomeRange":"Kisaran Penghasilan",

		//Room
        "Room":"Kamar",
        "Room.name":"Nama",
        "Room.code":"Kode",
        "Room.category":"Kategori",
        "Room.facilities":"Fasilitas",
        "Room.defaultPrice":"Harga Standar",
        "Room.branchPrices":"Harga per Cabang",
        "Room.expenseAccount":"Akun Beban",
        "Room.salesAccount":"Akun Penjualan",
        "Room.salesReturnAccount":"Akun Retur Penjualan",
        "Room.salesItemDiscAccount":"Akun Diskon Penjualan",
        "Room.salesCommissionAccount":"Akun Komisi Penjualan",
        "Room.unbilledPayableAccount":"Akun Utang Yang Belum Ditagihkan",
        "Room.state":"Status",
        "room.activate":"Aktifkan",
		"Room.confirmTitle.action/activate":"Aktifkan",
		"Room.confirmContent.action/activate":"Apakah Anda yakin ingin mengaktifkan Kamar ini?",
		"Room.success.activate":"Kamar telah berhasil diaktifkan",
		"room.deactivate":"Nonaktifkan",
		"Room.confirmTitle.action/deactivate":"Nonaktifkan",
		"Room.confirmContent.action/deactivate":"Apakah Anda yakin ingin menonaktifkan Kamar ini?",
		"Room.success.deactivate":"Kamar telah berhasil dinonaktifkan",
    
        //Room Category
		"RoomCategory":"Kategori Kamar",
		"room_category":"Kategori Kamar",
		"room_category.activate":"Aktifkan",
		"RoomCategory.confirmTitle.action/activate":"Aktifkan",
		"RoomCategory.confirmContent.action/activate":"Apakah Anda yakin ingin mengaktifkan Kategori Kamar ini?",
		"RoomCategory.success.activate":"Kategori Kamar telah berhasil diaktifkan",
		"room_category.deactivate":"Nonaktifkan",
		"RoomCategory.confirmTitle.action/deactivate":"Nonaktifkan",
		"RoomCategory.confirmContent.action/deactivate":"Apakah Anda yakin ingin menonaktifkan Kategori Kamar ini?",
		"RoomCategory.success.deactivate":"Kategori Kamar telah berhasil dinonaktifkan",
		"RoomCategory.code":"Kode",
		"RoomCategory.name":"Nama",
		"RoomCategory.cleanUrl":"Clean URL",
		"RoomCategory.parentId":"Kategori Induk",
		"RoomCategory.parent":"Kategori Induk",
		"RoomCategory.image":"Gambar",
		"RoomCategory.thumbnail":"Cuplikan",
		"RoomCategory.state":"Status",
		"RoomCategory.hideOnReport":"Sembunyikan Dari Laporan",
		"RoomCategory.saleableOnline":"Dapat Dijual Online",

        //Item Spec
		"ItemSpec":"Spesifikasi",
		"item_spec":"Spesifikasi Barang",
		"ItemSpec.name":"Nama",
		"ItemSpec.image":"Gambar",
		"ItemSpec.priority":"Prioritas",
		"ItemSpec.state":"Status",
		"ItemSpec.activate":"Aktifkan",
		"ItemSpec.deactivate":"Nonaktifkan",
		"ItemSpec.confirmTitle.action/activate":"Aktifkan",
		"ItemSpec.confirmTitle.action/deactivate":"Nonaktifkan",
		"ItemSpec.confirmContent.action/activate":"Apa Anda yakin akan mengaktifkan spesifikasi ini?",
		"ItemSpec.confirmContent.action/deactivate":"Apa Anda yakin akan menonaktifkan spesifikasi ini?",
		"ItemSpec.success.action/activate":"Spesifikasi berhasil diaktifkan",
		"ItemSpec.success.action/deactivate":"Spesifikasi berhaisl dinonaktifkan",

		"OnlineBooking":"Booking Online",
		"OnlineBooking.customerInfo":"Informasi Tamu",
		"OnlineBooking.customerName":"Nama Tamu",
		"OnlineBooking.customerMobile":"Nomor HP",
		"OnlineBooking.email":"E-mail",
		"OnlineBooking.customerContact":"Kontak Tamu",
		"OnlineBooking.extraDiscount":"Diskon Tambahan",
		"OnlineBooking.resendInvoice":"Kirim Ulang Tagihan",
		"OnlineBooking.confirmShipment":"Konfirmasi Check In",
		"OnlineBooking.completeOrder":"Konfirmasi Check Out",
		"OnlineBooking.accept":"Terima",
		"OnlineBooking.reject":"Tolak",
		"OnlineBooking.cancellationReason":"Alasan Penolakan",

		"CheckedOut":"Sudah Check-out",

		"CancelledBooking":"Booking Dibatalkan",

		"Customer":"Pelanggan",

		"SalesReport":"Laporan Penjualan",

		"waiting_approval":"Book",
		"waiting_payment":"Tunggu Bayar",
		"waiting_shipment":"Belum Datang",
		"shipped":"Check In",
		"arrived":"Check Out",


    },
    en:{
        Hospitality:"Hospitality",
        HospitalityReport:"Hospitality Report",
        HospitalityConfiguration:"Hospitality Configuration",

		//Partner
		"Partner":"Partner",
		"partner":"Partner",
		"partner.activate":"Activate",
		"Partner.confirmTitle.activate":"Activate",
		"Partner.confirmContent.activate":"Are you sure you want to activate this Partner?",
		"Partner.success.activate":"Partner is successfully activated",
		"partner.deactivate":"Deactivate",
		"Partner.confirmTitle.deactivate":"Deactivate",
		"Partner.confirmContent.deactivate":"Are you sure you want to deactivate this Partner?",
		"Partner.success.deactivate":"Partner is successfully deactivated",
		"Partner Information":"Partner Information",
		"Partner.name":"Name",
		"Partner.isSupplier":"Supplier",
		"Partner.isCustomer":"Customer",
		"Partner.email":"Email",
		"Partner.mobile":"Mobile Phone",
		"Partner.contact":"Home Phone",
		"Partner.street":"Address",
		"Partner.cityId":"City",
		"Partner.city":"City",
		"Partner.provinceId":"Province",
		"Partner.province":"Province",
		"Partner.countryId":"Country",
		"Partner.country":"Country",
		"Partner.zip":"Zip",
		"Partner.ssid":"SSID",
		"Partner.idAttachment":"SSID Attachment",
		"Finance and Accounting":"Finance and Accounting",
		"Partner.unlimitedCredit":"Unlimited Credit",
		"Partner.creditLimit":"Credit Limit",
		"Partner.credit":"Credit",
		"Partner.debitLimit":"Debit Limit",
		"Partner.debit":"Debit",
		"Partner.taxable":"Taxable",
		"Partner.npwp":"NPWP",
		"Partner.purchaseInvoiceDaysDue":"Purchase Invoice Due (Days)",
		"Partner.salesInvoiceDaysDue":"Sales Invoice Due (Days)",
		"Partner.defaultCurrencyId":"Currency Default",
		"Partner.defaultCurrency":"Currency Default",
		"Branch Information":"Branch Information",
		"Partner.branchId":"Branch",
		"Partner.branch":"Branch",
		"Company Information":"Company Information",
		"Partner.isCompany":"Company",
		"Partner.companyName":"Company Name",
		"Partner.companyNpwp":"Company NPWP",
		"Partner.companyAddress":"Company Address",
		"Partner.companyCityId":"Company City",
		"Partner.companyCity":"Company City",
		"Partner.companyProvinceId":"Company Province",
		"Partner.companyProvince":"Company Province",
		"Partner.companyCountryId":"Company Country",
		"Partner.companyCountry":"Company Country",
		"Partner.companyZip":"Company Zip",		
		"Other Information":"Other Information",
		"Partner.nodeId":"Node",
		"Partner.node":"Node",
		"Partner.joinDate":"Join Date",
		"Partner.media":"Media",
		"Partner.class":"Class",
		"Partner.code":"Code",
		"Partner.state":"State",
		"Partner.purchasing":"Purchasing",
		"Partner.purchasingUsers":"Purchasing Staffs",
		"Partner.user":"Staff Name",
		"Partner.birthDate":"Birthdate",
		"Partner.idNumber":"ID Number",
		"Partner.idAddress":"ID Address",
		"Partner.address":"Full Address",
		"Partner.occupation":"Occupcation",
		"Partner.maritalStatus":"Marital Status",
		"Partner.incomeRange":"Income Range",

        "Room":"Room",
        "Room.name":"Name",
        "Room.code":"Code",
        "Room.category":"Category",
        "Room.facilities":"Facilities",
        "Room.defaultPrice":"Default Price",
        "Room.branchPrices":"Branch Prices",
        "Room.expenseAccount":"Expense Account",
        "Room.salesAccount":"Sales Account",
        "Room.salesReturnAccount":"Sales Return Account",
        "Room.salesItemDiscAccount":"Sales Item Discount Account",
        "Room.salesCommissionAccount":"Sales Commission Account",
        "Room.unbilledPayableAccount":"Unbilled Payable Account",
        "Room.state":"Status",
        "room.activate":"Activate",
		"Room.confirmTitle.action/activate":"Activate",
		"Room.confirmContent.action/activate":"Are you sure want to activate this room?",
		"Room.success.activate":"Room has successfully activated",
		"room.deactivate":"Deactivate",
		"Room.confirmTitle.action/deactivate":"Deactivate",
		"Room.confirmContent.action/deactivate":"Are you sure want to deactivate this room?",
		"Room.success.deactivate":"Room has successfully deactivated",
    
        //Room Category
		"RoomCategory":"Room Category",
		"room_category":"Room Category",
		"room_category.activate":"Activate",
		"RoomCategory.confirmTitle.action/activate":"Activate",
		"RoomCategory.confirmContent.action/activate":"Are you sure want to activate this room category?",
		"RoomCategory.success.activate":"Room category has successfully activated",
		"room_category.deactivate":"Deactivate",
		"RoomCategory.confirmTitle.action/deactivate":"Deactivate",
		"RoomCategory.confirmContent.action/deactivate":"Are you sure want to deactivate this room category?",
		"RoomCategory.success.deactivate":"Room category has successfully deactivated",
		"RoomCategory.code":"Code",
		"RoomCategory.name":"Name",
		"RoomCategory.cleanUrl":"Clean URL",
		"RoomCategory.parentId":"Parent Category",
		"RoomCategory.parent":"Parent Category",
		"RoomCategory.image":"Image",
		"RoomCategory.thumbnail":"Thumbnail",
		"RoomCategory.state":"Status",
		"RoomCategory.hideOnReport":"Hide on report",
		"RoomCategory.saleableOnline":"Saleable online",

        //Item Spec
		"ItemSpec":"Specification",
		"item_spec":"Specification",
		"ItemSpec.name":"Name",
		"ItemSpec.image":"Image",
		"ItemSpec.priority":"Priority",
		"ItemSpec.state":"State",
		"ItemSpec.activate":"Activate",
		"ItemSpec.deactivate":"Deactivate",
		"ItemSpec.confirmTitle.action/activate":"Activate",
		"ItemSpec.confirmTitle.action/deactivate":"Deactivate",
		"ItemSpec.confirmContent.action/activate":"Are you sure want to activate this item specification",
		"ItemSpec.confirmContent.action/deactivate":"Are you sure want to deactivate this item specification",
		"ItemSpec.success.action/activate":"Item specification has successfully activated",
		"ItemSpec.success.action/deactivate":"Item specification has successfully deactivated",

		"OnlineBooking":"Online Booking",

		"CheckedOut":"Checked Out",

		"CancelledBooking":"Cancelled Booking",

		"Customer":"Customer",
		
		"SalesReport":"Sales Report",

		"waiting_approval":"Book",
		"waiting_payment":"Waiting Payment",
		"waiting_shipment":"Waiting Arrival",
		"shipped":"Checked-In",
		"arrived":"Checked-Out"

    }
}

export default Translation